import { FC } from 'react';
import { SiPayModal } from 'utilities/components';
import { BsExclamationTriangle } from 'react-icons/bs';
import { Button } from '../button/button.index';

interface Props {
    isOpen: boolean;
    onClose: () => void;
}

const PARAGRAPHS = [
    'کاربر گرامی، برای شارژ سریعتر کیف پول ریالی، پیشنهاد میکنیم حتما از روش واریز خودکار به جای آفلاین استفاده کنید.',
    'با واریز خودکار بدون نیاز به ارسال فیش بانکی، کیف پول شما حداقل دو برابر سریع‌ تر شارژ می‌شود.',
];

export const OfflineDepositNoticeModal: FC<Props> = ({ isOpen, onClose }) => {
    return (
        <SiPayModal isOpen={isOpen} onClose={onClose} maxWidth={440}>
            <div className="w-full flex flex-col items-center text-center">
                <div className="w-16 h-16 rounded-full bg-badge-warningBg flex items-center justify-center">
                    <BsExclamationTriangle size={28} className="text-warning-default" />
                </div>
                <span className="font-bold text-xl text-black-100 mt-5">اطلاعیه مهم</span>
                <div className="flex flex-col gap-4 mt-4">
                    {PARAGRAPHS.map((paragraph, index) => (
                        <p key={index} className="font-medium text-base text-black-100 leading-8">
                            {paragraph}
                        </p>
                    ))}
                </div>
                <Button type="primary" className="w-full mt-8" onClick={onClose}>
                    متوجه شدم
                </Button>
            </div>
        </SiPayModal>
    );
};
